/**
 * Arlo SFCC Static
 * New PLP Page entry point.
 */
import BundleCarousel from './components/BundleCarousel';
import AnchorCards from './components/AnchorCards';
import SmartOverviewSlider from './components/SmartOverviewSlider';
import BackToTop from './components/BackToTop';
import FooterAnimate from './components/FooterAnimate';
import Modal from './components/Modal';

new SmartOverviewSlider('#smart-overview-first'); // eslint-disable-line no-new
new AnchorCards(); // eslint-disable-line no-new
new BundleCarousel(); // eslint-disable-line no-new
new BackToTop(); // eslint-disable-line no-new
new FooterAnimate(); // eslint-disable-line no-new

 /**
 * Define the scroll event handler function
 */
function scrollHandler() {
    var scrollPosition = window.scrollY;
    var scrollCoordinates = window.promoOverlayPosition;
    if (scrollPosition >= scrollCoordinates) {
        // Trigger the email signup pop-up here
        new Modal('promo-overlay-content');  // eslint-disable-line no-new
        // Remove the scroll event listener after the modal is triggered
        window.removeEventListener('scroll', scrollHandler);
    }
}

// Attach the scroll event listener
window.addEventListener('scroll', scrollHandler);

 /**
 *
 * The function actually applying the offset
 */
function offsetAnchor() {
    if (location.hash.length !== 0) {
        window.scrollTo(window.scrollX, window.scrollY - 100);
    }
}

// Captures click events of all <a> elements with href starting with #
$('body').on('click', 'article.anchor-cards__product-card a[href^="#"]', function () {
    // Click events are captured before hashchanges. Timeout
    // causes offsetAnchor to be called after the page jump.
    window.setTimeout(function () {
        offsetAnchor();
    }, 0);
});

 // Set the offset when entering page with hash present in the url
window.setTimeout(offsetAnchor, 0);
